// src/utils/api.js

const AUTH0_AUDIENCE = 'https://blockrivals.com/blockapi'; 

const API_STAGE_KEY = 'blockduel_api_stage';

// Decide which API stage to use based on query string or sessionStorage
export function getApiStage() {
  const params = new URLSearchParams(window.location.search);
  const apiFromQuery = params.get('api');

  // 1) if specified in query string, use it and store it in sessionStorage
  if (apiFromQuery === 'dev' || apiFromQuery === 'prod') {
    sessionStorage.setItem(API_STAGE_KEY, apiFromQuery);
    return apiFromQuery;
  }

  // 2) if not specified in query string, but saved in sessionStorage, use it
  const stored = sessionStorage.getItem(API_STAGE_KEY);
  if (stored === 'dev' || stored === 'prod') {
    return stored;
  }

  // 3) default is prod
  return 'prod';
}

// Get WebSocket URL for the current stage
export function getWebSocketUrl() {
  const stage = getApiStage();
  console.log('API stage = ' + stage);
  if (stage === 'dev') {
    return 'wss://3alab38nob.execute-api.us-east-1.amazonaws.com/dev';
  }
  return 'wss://l4nz0ed83d.execute-api.us-east-1.amazonaws.com/prod';
}


export async function getAuth0AccessToken(getAccessTokenSilently) {
  console.log("My code is used by nobukichi");
  const accessToken = await getAccessTokenSilently({
    authorizationParams: {
      audience: AUTH0_AUDIENCE,
      scope: 'openid profile email',
    },
  });
  return accessToken;
}
